import { Link, useHistory, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";

const account_data_api_url = "https://fcsn6t.deta.dev/account/google_data";
const articles_data_url = "https://fcsn6t.deta.dev/article/all";

const useStyles = makeStyles({
  container: {
    "min-height": "100vh",
    padding: "0 0.5rem",
    display: "flex",
    "flex-direction": "column",
    "justify-content": "center",
    "align-items": "center",
  },
  main: {
    padding: "5rem 0",
    flex: "1",
    display: "flex",
    "flex-direction": "column",
    "justify-content": "center",
    "align-items": "center",
  },
  article_container: {
    marginTop: "2em"
  },
  article: {
    marginTop: "2.3em",
    marginLeft: "4px",
    border: "3px solid black"
  }
});

const Home = () => {
  const [userData, setUserdata] = useState({
    user_name: null,
    token: null,
  });
  const [articles, setArticles] = useState(null);
  const [apiError, setApierror] = useState("");
  const router_hystory = useHistory();
  const router_location = useLocation();
  const styles = useStyles();
  const checkLogin = (session_token) => {
    //this function make a request to api and check login
    fetch(account_data_api_url, {
      method: "GET",
      headers: {
        "X-Token": session_token,
      },
    })
      .then((data) => data.json())
      .then((json) => {
        if (json.error) {
          if (json.error === "Token expire") {
            console.log("Token expire");
            router_hystory.push("/login");
          } else {
            setApierror(json.error + " Reload page");
            window.location.pathname = router_location.pathname;
          }
        } else {
          setUserdata({
            ...userData,
            token: session_token.tokenId,
            user_name: json.name,
          });
          getAllarticles(session_token);
        }
      });
  };
  const getAllarticles = (session_token) => {
    fetch(articles_data_url, {
      method: "GET",
      headers: {
        "X-Token": session_token,
      },
    })
      .then((data) => data.json())
      .then((json) => {
        if (json.error) {
          setApierror(json.error + " Reload page");
          window.location.pathname = router_location.pathname;
        } else {
          setArticles(json);
        }
      });
  };

  useEffect(() => {
    console.log(router_location.pathname);
    //this function get token from session
    let storToken = sessionStorage.getItem("xtoken");
    if (storToken) {
      let xtoken = { tokenId: JSON.parse(storToken).id_token };
      checkLogin(xtoken.tokenId);
    } else {
      router_hystory.push("/login");
    }
  }, []);

  const get_user_data_viewer = () => {
    if (userData.user_name) {
      return <Link to="/user">{userData.user_name}</Link>;
    } else {
      return <span></span>;
    }
  };
  let user_data_viewer = get_user_data_viewer();

  const get_articles_viewer = () => {
    if (articles) {
      return articles.map((item, index) => {
        return (
          <article key={index} className={styles.article}>
            <h4>{item.title}</h4>
            <p>{item.body}</p>
            <p>{item.author}</p>
          </article>
        );
      });
    } else {
      return <span>Caricamento...</span>;
    }
  };
  let articles_viewer = get_articles_viewer();
  return (
    <div className={styles.container}>
      <main className={styles.main}>
        <h1>Hello {user_data_viewer}</h1>
        {apiError}
        <div className={styles.article_container}>{articles_viewer}</div>
      </main>
    </div>
  );
};

export default Home;
